var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("h6", { staticClass: "font-weight-normal" }, [
            _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.title`))),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "mt-1" }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { attrs: { id: "layer-types-accordion" } },
            _vm._l(_vm.subtypes, function (type, idx) {
              return _c(
                "div",
                { key: `type-${idx}`, staticClass: "card accordion" },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col",
                          attrs: {
                            id: "heading" + type.id,
                            "data-toggle": "collapse",
                            "data-target": "#collapse" + type.id,
                            "aria-expanded": "true",
                            "aria-controls": "collapse" + type.id,
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(type.name) +
                              "\n                                "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse" + type.id,
                        "aria-labelledby": "heading" + type.id,
                        "data-parent": "#layer-types-accordion",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card-body py-3" },
                        _vm._l(type.subtypes, function (subtype) {
                          return _c(
                            "div",
                            {
                              key: subtype.id,
                              staticClass:
                                "form-check city-form-check px-0 px-sm-2 mb-1",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.items,
                                    expression: "items",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "",
                                    expression: "''",
                                  },
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "checkbox",
                                  disabled: _vm.readonlyForm,
                                  id: "checkSubtype" + subtype.id,
                                  name: "checkSubtype" + subtype.id,
                                  "data-vv-scope": _vm.vScope,
                                },
                                domProps: {
                                  value: _vm.valueCheckbox(subtype.id),
                                  checked: Array.isArray(_vm.items)
                                    ? _vm._i(
                                        _vm.items,
                                        _vm.valueCheckbox(subtype.id)
                                      ) > -1
                                    : _vm.items,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.items,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = _vm.valueCheckbox(subtype.id),
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.items = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.items = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.items = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "checkSubtype" + subtype.id },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(subtype.name) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }